// extracted by mini-css-extract-plugin
module.exports = {"overviewLayout":"OverviewLayout_overviewLayout__1vRNn","leftColumn":"OverviewLayout_leftColumn__15Yy8","rightColumn":"OverviewLayout_rightColumn__1l4Vs"};